<template>
  <div v-if="AdList.manData && AdList.manData.length" :class="containerClass? 'ad-wrapper' : 'normal-ad-wrapper'" :style="adStyle">
    <div v-show="adStyle || !containerClass" class="ad-img">
      <img :class="imgType=='toast'&&'toast-img'"
           ref="adImg"
           :src="AdData.qnUrl"
           @click="handleLink(AdData)"
           @load="loadAdStyle"
      >
    </div>
    <wx-open-launch-weapp
      v-if="wxconfig && isWeappShow"
      id="launch-btn"
      :username="AdData.weappId"
      :path="AdData.weappUrl"
      v-log="{
        event_type: 'click',
        event_name: `点击${type}页横条广告跳转小程序-${adDataName}`,
      }"
    >
      <script type="text/wxtag-template">
        <style>
          .ctn{
            width: 100%;
            height: 100vw;
          }
        </style>
        <div class="ctn"></div>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>
<script>
/**
 * 横条广告
 * AdData:
 *  linkType: 广告类型
 *    1 外链（站外） - location.href
 *    2 内部（站内） - route
 *    3 小程序 - 中转页1 或 弹窗2
 */
import { utils, Stat } from '@/libs/interfaces';
import get from 'lodash/get';
import random from 'lodash/random';

import AdControlMixin from './mixin';
import { mapState } from 'vuex'

export default {
  mixins: [AdControlMixin],
  props: {
    imgType: String, // banner(默认) toast(弹窗上方竖版广告)
    position: String,
    containerClass: String,
    reportType: String,
  },
  data() {
    return {
      AdList: [],
      type: '',
      adStyle: '',
    };
  },
  computed: {
    ...mapState({
      wxconfig: (state) => state.wxconfig,
    }),
    vipText() {
      return this.$store.state.is_vip ? 'vip' : '非vip';
    },
    have_gift() {
      return this.$store.state.have_gift;
    },
    sex() {
      return this.$store.state.sex;
    },
    AdData() {
      const keyName = this.position ? `ad${this.position}` : `ad${this.$route.name}`;
      let index = Number(utils.cookie.getCookie(keyName) || 0);
      const data = this.sex === 2 ? this.AdList.womanData : this.AdList.manData;
      if (data.length) {
        index = (data.length - 1) > index ? index + 1 : 0;
        utils.cookie.setCookie(index, 0.25, keyName);
      }
      return get(data, index, {});
    },
    adDataName() {
      return get(this.AdData, 'name', '')
    },
    isWeappShow() {
      return this.AdData.linkType == 3 && this.AdData.miniprogramTransType == 3 && this.AdData.weappId
    },
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    loadAdStyle() {
      setTimeout(() => {
        this.setAdStyle();
      }, 200);
    },
    setAdStyle() {
      if (!this.containerClass) return;
      this.adStyle = 'width: 10px';
      this.$nextTick(() => {
        // 视窗宽高
        const winHeight = window.innerHeight || document.body && document.body.clientHeight;
        const winWidth = window.innerWidth || document.body && document.body.clientWidth;
        const restHeight = winHeight - document.querySelector(this.containerClass).offsetHeight; // 剩余高
        const adRatio = this.$refs.adImg.offsetWidth / this.$refs.adImg.offsetHeight; // 广告图宽高比
        const resetRatio = winWidth / restHeight; // 剩余区域宽高比

        let designWidth = 0; // 显示广告宽
        let designHeight = 0; // 显示广告高
        if (adRatio < 1) { // 长图
          designHeight = 0.7 * restHeight;
          designWidth = designHeight * adRatio;
        } else if (adRatio < 1.5) { // 宽高比差不多的图
          designWidth = 0.7 * winWidth / resetRatio;
          designHeight = designWidth / adRatio;
        } else { // 宽图
          designWidth = 0.7 * winWidth;
          designHeight = designWidth / adRatio;
        }
        // 因为容器是绝对定位 所以要计算出距离遥控容器的top 为了便于理解下面计算没有做合并
        const restTop = designHeight + (restHeight - designHeight) * 0.5;
        this.adStyle = `width: ${designWidth}px;height:${designHeight}px;top:-${restTop}px;`;
      });
    },
    handleLink(adData) {
      if (adData.name) {
        this.$sendLog({
          event_type: 'click',
          event_name: `${this.type}页横条广告点击`,
          event_data: {
            name: adData.name,
          },
        });
      }
      if (adData.linkType === this.AdLinkTypeMap.MINPROGRAM) {
        this.handleMiniprogramAd(adData);
        return;
      }
      // 历史逻辑
      if (this.position) {
        switch (this.position) {
          case 'playControl':
            this.type = '遥控';
            break;
          case 'barrage':
            this.type = '发弹幕';
            break;
          default:
            this.type = '发弹幕';
            break;
        }
      }
      if (adData.action === 3) {
        _hmt.push(['_trackEvent', '我的', '点击体验会员', 'vip']);
        Stat({ tp: '我的页', desc: '点击体验会员' });
        utils.util.buyVipPlus({
          $this: this,
          pay_enter: 'mineAdVip',
        });
        return;
      }
      if (!adData.route) return;
      this.$sendLog({
        tp: `${this.type}页横条广告-点击进入`, desc: `${this.sexText}点击量`, category: `横条广告${this.sexText}点击`, optLabel: `${this.sexText}点击量`,
      });
      if (adData.route === 'letter') {
        this.$sendLog({
          tp: '一封家书横条广告-点击进入', desc: '一封家书点击量', category: '横条广告一封家书点击', optLabel: '一封家书',
        });
        const raiseUrl = random(0, 9) < 7 ? 'https://qncweb-back1.ktvsky.com/20200928/vadd/43944f4a055165190d3a0062c3f6223e.png' : 'https://qncweb-back1.ktvsky.com/20200928/vadd/5b8060f8326850f2ea17a44a2ca0c28c.png';
        this.$RaiseMessage.alert(raiseUrl, '');
        return;
      }
      if (adData.linkType === this.AdLinkTypeMap.INNER) {
        if (adData.route.includes('fromType')) {
          this.$router.push(adData.route);
          return;
        }
        this.$jump(adData.route, 'AD');
        return;
      }
      location.href = adData.route;
    },
    getInfo() {
      this.type = this.reportType || this.$route.meta.title;
      const keyName = this.position ? `ad${this.position}` : `ad${this.$route.name}`;
      this.$store.dispatch('getData', {
        keyName,
        callback: (res) => {
          this.AdList = get(res, 'data.bannerData', {});
          if (keyName === 'admineVip') {
            this.$sendLog({
              tp: `${this.type}页${this.vipText}横条广告-展示`,
              desc: `${this.sexText}${this.vipText}展示量`,
              category: '广告展示量',
              optLabel: `${this.sexText}${this.vipText}展示量`,
            });
            this.$sendLog({
              tp: `${this.type}页${this.vipText}横条广告总-展示`,
              desc: `${this.vipText}总展示量`,
              category: '广告展示量',
              optLabel: `${this.vipText}总展示量`,
            });
          } else {
            this.$sendLog({
              tp: `${this.type}页横条广告-展示`,
              desc: `${this.sexText}展示量`,
              category: '广告展示量',
              optLabel: `${this.sexText}展示量`,
            });
            this.$sendLog({
              tp: `${this.type}页横条广告总-展示`,
              desc: '总展示量',
              category: '广告展示量',
              optLabel: '总展示量',
            });
          }
          this.$sendLog({
            event_type: 'show',
            event_name: `${this.type}横条广告运营位`,
            event_data: {
              isLog6: true,
              name: this.adDataName,
              sex: this.sexText,
            },
          });
          this.$sendLog({
            event_type: 'show',
            event_name: `${this.type}页横条广告展示`,
            event_data: {
              isLog6: true,
              name: this.adDataName,
            },
          });
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.ad-title {
  font-size: 34px;
  font-weight: 700;
  color: #333;
  margin-bottom: 22px;
}
.normal-ad-wrapper {
  width: 690px;
  margin: 20px auto 0;
  position: relative;
}
.ad-wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  .ad-img {
    width: 100%;
  }
  img {
    width: 100%;
    height: auto;
  }
}
#launch-btn {
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: transparent;
  overflow: hidden;
}
</style>
